<template>
	<div class="search-item smooth-trans" @click="jump">
		<div class="item-icon"><img :src="url"></div>
		<div class="item-brief">
			<div class="brief-title">
				{{this.category}}: {{this.title}}
			</div>
			<div class="brief-message">
				description: {{data.des}}
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'searchItem',
	props:['data'],
	computed:{
        url(){
            let url=(this.data.uid)?this.$store.state.baseUrl+'/userPic/'+this.data.uid:this.$store.state.baseUrl+'/groupPic/'+this.data.cid;
            if(this.data.cid){
                if(this.data.p2p === 1){
                    let targetUid=(this.data.peer1 === this.$store.state.UID)?this.data.peer2:this.data.peer1;
                    url=this.$store.state.baseUrl+'/userPic/'+targetUid;
                }
            }
            return url
		},
		title(){
            let title=(this.data.title)?this.data.title:this.data.name;
            if(this.data.cid){
                if(this.data.p2p === 1){
                    let usernames=this.data.title.split(',');
                    title= (usernames[0] === this.$store.state.userName)?usernames[1]:usernames[0];
                }
            }
			return title
		},
        category:function(){
            return (this.data.cid)?'group':'user';
        }
    },
    methods:{
        jump:function(){
            if(this.category === 'group'){
                this.$emit('show-brief',{
                    showWhat:'quickProfile',
                    title:this.data.title,
                    url:this.url,
                    des:this.data.des,
                    category:'group',
                    cid:this.data.cid
                });
            }else if(this.category === 'user'){
                // this.$router.push({path:`/Profile/${this.data.uid}`,replace:true});
                this.$emit('show-brief',{
                    showWhat:'quickProfile',
                    title:this.title,
                    url:this.url,
                    des:this.data.des,
                    category:'user',
                    uid:this.data.uid
                });
            }
        }
    }
}
</script>

<style>
	.search-item {
		height: 72px;
		padding-left: 8px;
		/* padding-right: 2px; */
		margin-left: 4px;
		margin-right: 4px;
		display: flex;
		flex-direction: row;
		align-items: center;
		/* justify-content:space-between; */
		border-bottom: 1px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
	}

	.search-item:hover {
		background-color: rgb(128,128,128,0.15);
	}

	.search-item .item-icon {
		order: 1;
		width: 52px;
		height: 52px;
		border-radius: 50%;
		background-color: #8bc34a;
		overflow: hidden;
	}

	.search-item .item-icon img {
		max-height:100%; 
		max-width:100%;
		object-fit: contain;
		overflow: hidden;
	}

	.search-item .item-brief {
		order: 2;
		padding-left: 6px;
		/* width: calc(100% - 130px); */
		display: flex;
		flex-direction: column;
		white-space:nowrap;
		word-break: break-all;
	}

	.search-item .item-brief .brief-title {
		order: 1;
		line-height: 35px;
		font-size: 25px;
		overflow:hidden;  
	}

	.search-item .item-brief .brief-message {
		order: 2;
		line-height: 25px;
		font-size: 20px;
		overflow:hidden;  
		text-overflow: ellipsis;
	}

</style>
